import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { View } from 'foundations-components/components/View';
import RequestForm from '../components/RequestForm';
import { captureException } from '../utils/captureException';
import { getRequestTypes, isSubmitButtonDisabled } from '../utils/form';
import { jsx as _jsx } from "react/jsx-runtime";
function PreviewContainer() {
  var _dataPrivacyConfig$br, _dataPrivacyConfig$br2;
  const [requestType, setRequestType] = useState(undefined);
  const [country, setCountry] = useState('');
  const [email, setEmail] = useState('');
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const {
    search
  } = useLocation();
  const dataPrivacyConfig = useMemo(() => {
    const defaultValue = {
      branding: {
        companyName: undefined,
        logoAltText: '',
        logoUrl: undefined
      },
      email: 'company-admin@company.com',
      requestTypes: {
        DELETE_REQUEST: true,
        EXPORT_REQUEST: true
      },
      urlSlug: 'url-slug',
      showCountrySetting: 'ENABLED_AND_ENFORCED',
      recaptchaEnabled: true
    };
    const params = new URLSearchParams(search);
    const value = params.get('config');
    try {
      return Object.assign({}, defaultValue, value ? JSON.parse(decodeURIComponent(value)) : {});
    } catch (err) {
      captureException(err, ['PreviewContainer: Error parsing data privacy config']);
    }
    return defaultValue;
  }, [search]);
  const requestTypes = useMemo(() => getRequestTypes(dataPrivacyConfig), [dataPrivacyConfig]);
  const submitButtonDisabled = useMemo(() => isSubmitButtonDisabled(dataPrivacyConfig, requestType, country, email, recaptchaToken), [dataPrivacyConfig, requestType, country, email, recaptchaToken]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "PREVIEW_LOAD",
    children: /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-tertiary-subtle",
      minBlockSize: "100vh",
      "data-test-id": "preview-form-container",
      children: /*#__PURE__*/_jsx(RequestForm, {
        country: country,
        email: email,
        logoAltText: dataPrivacyConfig === null || dataPrivacyConfig === void 0 || (_dataPrivacyConfig$br = dataPrivacyConfig.branding) === null || _dataPrivacyConfig$br === void 0 ? void 0 : _dataPrivacyConfig$br.logoAltText,
        logoUrl: (_dataPrivacyConfig$br2 = dataPrivacyConfig.branding) === null || _dataPrivacyConfig$br2 === void 0 ? void 0 : _dataPrivacyConfig$br2.logoUrl,
        onChangeCountry: setCountry,
        onChangeEmail: setEmail,
        onChangeRecaptchaToken: setRecaptchaToken,
        onChangeRequestType: setRequestType,
        onSubmit: () => {},
        requestType: requestType,
        requestTypes: requestTypes,
        submitButtonDisabled: submitButtonDisabled,
        businessEmail: dataPrivacyConfig === null || dataPrivacyConfig === void 0 ? void 0 : dataPrivacyConfig.email,
        isRecaptchaEnabled: !!(dataPrivacyConfig !== null && dataPrivacyConfig !== void 0 && dataPrivacyConfig.recaptchaEnabled),
        showCountrySetting: dataPrivacyConfig === null || dataPrivacyConfig === void 0 ? void 0 : dataPrivacyConfig.showCountrySetting
      })
    })
  });
}
export default PreviewContainer;